module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="radio-strip-wrap"><div class="radio-strip btns-'+
((__t=( options.length ))==null?'':__t)+
' clearfix" data-element="radio-strip"> ';
 _.each(options, function(option) { 
__p+=' <label><input type="radio" value="'+
((__t=( option.value ))==null?'':__t)+
'" name="'+
((__t=( name ))==null?'':__t)+
'"> <span>'+
((__t=( option.title ))==null?'':__t)+
'</span></label> ';
 }) 
__p+=' <div class="radio-strip-slider" data-element="strip-slider"></div></div></div>';
}
return __p;
};
